import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["background", "overlay", "logoXPosition", "logoYPosition", "scale"]

  connect() {
    this.dragging = false;

    // Apply initial position and scale
    this.updateOverlayPosition();
    this.updateOverlaySize();

    this.overlayTarget.addEventListener("mousedown", this.startDrag.bind(this));
    document.addEventListener("mousemove", this.drag.bind(this));
    document.addEventListener("mouseup", this.endDrag.bind(this));
  }

  updateOverlayPosition() {
    const xPercent = parseFloat(this.logoXPositionTarget.value) || 50;
    const yPercent = parseFloat(this.logoYPositionTarget.value) || 50;

    this.overlayTarget.style.left = `${xPercent}%`;
    this.overlayTarget.style.top = `${yPercent}%`;
    this.overlayTarget.style.transform = `translate(-50%, -50%)`; // Keep transform for centering
  }

  updateOverlaySize() {
    const scalePercentage = parseFloat(this.scaleTarget.value) || 100;
    const originalWidth = parseFloat(this.overlayTarget.dataset.originalWidth);
    const originalHeight = parseFloat(this.overlayTarget.dataset.originalHeight);

    const scaledWidth = (originalWidth * scalePercentage / 100.0).toFixed(2);
    const scaledHeight = (originalHeight * scalePercentage / 100.0).toFixed(2);

    this.overlayTarget.style.width = `${scaledWidth}px`;
    this.overlayTarget.style.height = `${scaledHeight}px`;
  }

  startDrag(event) {
    event.preventDefault();
    this.dragging = true;
    this.initialX = event.clientX;
    this.initialY = event.clientY;
  }

  drag(event) {
    if (!this.dragging) return;

    const dx = event.clientX - this.initialX;
    const dy = event.clientY - this.initialY;

    // Calculate the new position
    const currentLeft = parseFloat(this.overlayTarget.style.left);
    const currentTop = parseFloat(this.overlayTarget.style.top);

    this.overlayTarget.style.left = `${currentLeft + dx}px`;
    this.overlayTarget.style.top = `${currentTop + dy}px`;

    // Update initial position
    this.initialX = event.clientX;
    this.initialY = event.clientY;
  }

  endDrag() {
    if (!this.dragging) return;

    this.dragging = false;

    const rect = this.backgroundTarget.getBoundingClientRect();
    const overlayRect = this.overlayTarget.getBoundingClientRect();

    // Convert the new position to percentages relative to the background
    const xPercent = ((overlayRect.left + overlayRect.width / 2 - rect.left) / rect.width) * 100;
    const yPercent = ((overlayRect.top + overlayRect.height / 2 - rect.top) / rect.height) * 100;

    this.logoXPositionTarget.value = xPercent;
    this.logoYPositionTarget.value = yPercent;
  }
}
